import React from 'react';
import { useColorSync } from '../hooks/useColorSync';
import { reformatSyncedHslValues, validatedParsedHsl, VIEWS_TYPES } from '../colorPickerUtils';
import { useUnitChange } from '../hooks/useUnitChange';
import { SegmentField } from './SegmentField';

export const HslView = ({ onChange, value }) => {
  const {
    localState: hslInputState,
    handleBlur: handleHslBlur,
    handleChange: handleHslChange,
  } = useColorSync({
    watchedValue: value,
    onChange,
    validationFn: validatedParsedHsl,
    view: VIEWS_TYPES.HSL,
    formatFn: reformatSyncedHslValues,
  });
  const { handleUnitChange } = useUnitChange(handleHslChange, hslInputState);

  return (
    <>
      <SegmentField min={0} max={360} name="h" value={hslInputState.h} onBlur={handleHslBlur} onChange={handleUnitChange} />
      <SegmentField min={0} max={100} name="s" value={hslInputState.s} onBlur={handleHslBlur} onChange={handleUnitChange} />
      <SegmentField min={0} max={100} name="l" value={hslInputState.l} onBlur={handleHslBlur} onChange={handleUnitChange} />
      <SegmentField key="alpha" min={0} max={1} step={0.01} onBlur={handleHslBlur} name="a" value={hslInputState.a} onChange={handleUnitChange} />
    </>
  );
};
